<template>
	<div>
		<!-- attendance summary -->
		<div class="panel-summary-group row" v-if="!!summaryDetails">
			<div class="panel-summary panel-summary-warning col-md-12 col-lg-4">
				<div class="panel-header font-white">
					<h3 class="title">
						{{ $t('MAIN_CONTENT.AttendanceSummary.absencesLabel') }}
					</h3>

					<p class="text-center">
						<strong class="total">
							{{ summaryDetails.ABSENCES.TOTAL_DAYS }}
						</strong>
						<span class="unit">
							{{ $t('MAIN_CONTENT.AttendanceSummary.daysAllLowercase') }}
						</span>
					</p>
				</div>
				<div class="panel-body panel-body-table">
					<table class="table table-striped attendance-summary-table">
						<thead class="sr-only">
							<tr>
								<td></td>
								<th scope="col">
									{{ $t('MAIN_CONTENT.AttendanceSummary.daysAllCaps') }}
								</th>
							</tr>
						</thead>
						<tbody>
							<template>
								<tr>
									<th scope="row" class="stat-row-th">
										{{ $t('MAIN_CONTENT.AttendanceSummary.excusedWithColon') }}
									</th>
									<td class="stat-col">
										{{ summaryDetails.ABSENCES.EXCUSED }}
										<span>
											{{ $t('MAIN_CONTENT.AttendanceSummary.daysAllLowercase') }}
										</span>
									</td>
								</tr>

								<tr>
									<th scope="row" class="stat-row-th">
										{{ $t('MAIN_CONTENT.AttendanceSummary.unexcusedWithColon') }}
									</th>
									<td class="stat-col">
										{{ summaryDetails.ABSENCES.UNEXCUSED }}
										<span>
											{{ $t('MAIN_CONTENT.AttendanceSummary.daysAllLowercase') }}
										</span>
									</td>
								</tr>

								<tr>
									<th scope="row" class="stat-row-th">
										{{ $t('MAIN_CONTENT.AttendanceSummary.unlawfulWithColon') }}
									</th>
									<td class="stat-col">
										{{ summaryDetails.ABSENCES.UNLAWFUL }}
										<span>
											{{ $t('MAIN_CONTENT.AttendanceSummary.daysAllLowercase') }}
										</span>
									</td>
								</tr>
							</template>
						</tbody>
					</table>
				</div>
			</div>
			<!-- Tardy / Early Dismissal Summary -->
			<div class="panel-summary panel-summary-gold col-md-12 col-lg-8">
				<div class="panel-header font-white">
					<h3 class="title">
						{{ $t('MAIN_CONTENT.AttendanceSummary.tardySlashEarlyDismissal') }}
					</h3>

					<p class="text-center" v-if="!!summaryDetails.TARDY.TOTAL_EARLY_DISMISSAL">
						<strong class="total">
							{{ summaryDetails.TARDY.TOTAL_EARLY_DISMISSAL }}
						</strong>
						<span class="unit">
							{{ $t('MAIN_CONTENT.AttendanceSummary.earlyAllCaps') }}
						</span>
					</p>

					<p class="text-center">
						<strong class="total">
							{{ summaryDetails.TARDY.TOTAL_TARDY }}
						</strong>
						<span class="unit">
							{{ $t('MAIN_CONTENT.AttendanceSummary.tardyAllCaps') }}
						</span>
					</p>

					<p class="text-center">
						<strong class="total">
							{{ summaryDetails.TARDY.TOTAL_MINUTES }}
						</strong>
						<span class="unit">
							{{ $t('MAIN_CONTENT.AttendanceSummary.minAllCaps') }}
						</span>
					</p>
				</div>
				<div class="panel-body panel-body-table">
					<table class="table table-striped attendance-summary-table">
						<thead class="sr-only">
							<tr>
								<td></td>
								<th scope="col">
									{{ $t('MAIN_CONTENT.AttendanceSummary.daysAllLowercase') }}
								</th>
							</tr>
						</thead>
						<tbody>
							<template>
								<tr v-if="!!summaryDetails.TARDY.EXCUSED.EARLY_DISMISSAL || !!summaryDetails.TARDY.EXCUSED.TARDY || !!summaryDetails.TARDY.EXCUSED.MINUTES">
									<th scope="row" class="stat-row-th">
										{{ $t('MAIN_CONTENT.AttendanceSummary.excusedWithColon') }}
									</th>
									<td class="stat-col">
										<template v-if="!!summaryDetails.TARDY.EXCUSED.EARLY_DISMISSAL">
											{{ summaryDetails.TARDY.EXCUSED.EARLY_DISMISSAL }}
											<span>
												{{ $t('MAIN_CONTENT.AttendanceSummary.earlyAllLowercase') }}
											</span> / 
										</template>
										<template v-if="!!summaryDetails.TARDY.EXCUSED.TARDY">
											{{ summaryDetails.TARDY.EXCUSED.TARDY }}
											<span>
												{{ $t('MAIN_CONTENT.AttendanceSummary.tardyAllLowercase') }}
											</span> / 
										</template>
										<template v-if="!!summaryDetails.TARDY.EXCUSED.MINUTES">
											{{ summaryDetails.TARDY.EXCUSED.MINUTES }}
											<span>
												{{ $t('MAIN_CONTENT.AttendanceSummary.minAllLowercase') }}
											</span>
										</template>
									</td>
								</tr>

								<tr v-if="!!summaryDetails.TARDY.UNEXCUSED.EARLY_DISMISSAL || !!summaryDetails.TARDY.UNEXCUSED.TARDY || !!summaryDetails.TARDY.UNEXCUSED.UNLAWFUL">
									<th scope="row" class="stat-row-th">
										{{ $t('MAIN_CONTENT.AttendanceSummary.unexcusedWithColon') }}
									</th>
									<td class="stat-col">
										<template v-if="!!summaryDetails.TARDY.UNEXCUSED.EARLY_DISMISSAL">
											{{ summaryDetails.TARDY.UNEXCUSED.EARLY_DISMISSAL }}
											<span>
												{{ $t('MAIN_CONTENT.AttendanceSummary.earlyAllLowercase') }}
											</span> / 
										</template>
											<template v-if="!!summaryDetails.TARDY.UNEXCUSED.TARDY">
											{{ summaryDetails.TARDY.UNEXCUSED.TARDY }}
											<span>
												{{ $t('MAIN_CONTENT.AttendanceSummary.tardyAllLowercase') }}
											</span> / 
										</template>
										<template v-if="!!summaryDetails.TARDY.UNEXCUSED.MINUTES">
											{{ summaryDetails.TARDY.UNEXCUSED.MINUTES }}
											<span>
												{{ $t('MAIN_CONTENT.AttendanceSummary.minAllLowercase') }}
											</span>
										</template>
									</td>
								</tr>

								<tr v-if="!!summaryDetails.TARDY.UNLAWFUL.EARLY_DISMISSAL || !!summaryDetails.TARDY.UNLAWFUL.TARDY || !!summaryDetails.TARDY.UNLAWFUL.UNLAWFUL">
									<th scope="row" class="stat-row-th">
										{{ $t('MAIN_CONTENT.AttendanceSummary.unlawfulWithColon') }}
									</th>
									<td class="stat-col">
										<template v-if="!!summaryDetails.TARDY.UNLAWFUL.EARLY_DISMISSAL">
											{{ summaryDetails.TARDY.UNLAWFUL.EARLY_DISMISSAL }}
											<span class="stat-col">
												{{ $t('MAIN_CONTENT.AttendanceSummary.earlyAllLowercase') }}
											</span> / 
										</template>
										<template v-if="!!summaryDetails.TARDY.UNLAWFUL.TARDY">
											{{ summaryDetails.TARDY.UNLAWFUL.TARDY }}
											<span>
												{{ $t('MAIN_CONTENT.AttendanceSummary.tardyAllLowercase') }}
											</span> / 
										</template>
										<template v-if="!!summaryDetails.TARDY.UNLAWFUL.MINUTES">
											{{ summaryDetails.TARDY.UNLAWFUL.MINUTES }}
											<span class="stat-col">
												{{ $t('MAIN_CONTENT.AttendanceSummary.minAllLowercase') }}
											</span>
										</template>
									</td>
								</tr>
							</template>
						</tbody>
					</table>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		props: {
			school: {
				type:			Array,
				required:	true
			}
		},
		data() {
			return {
				showAbsences: true,
				showTardy: false
			};
		},
		computed: {
			summaryDetails() {
				let summary = {
					ABSENCES: {
						EXCUSED: 0,
						UNEXCUSED: 0,
						UNLAWFUL: 0,
						TOTAL_DAYS: 0
					},
					TARDY: {
						EXCUSED: {
							TARDY: 0,
							MINUTES: 0,
							EARLY_DISMISSAL: 0
						},
						UNEXCUSED: {
							TARDY: 0,
							MINUTES: 0,
							EARLY_DISMISSAL: 0
						},
						UNLAWFUL: {
							TARDY: 0,
							MINUTES: 0,
							EARLY_DISMISSAL: 0
						},
						TOTAL_TARDY: 0,
						TOTAL_MINUTES: 0,
						TOTAL_EARLY_DISMISSAL: 0
					}
				};

				for(let s in this.school) {
					let sch = this.school[s];

					// Absences summary
					summary.ABSENCES.EXCUSED += !!sch.EXCUSED_COUNT ? sch.EXCUSED_COUNT : 0;
					summary.ABSENCES.UNEXCUSED += !!sch.UNEXCUSED_COUNT ? sch.UNEXCUSED_COUNT : 0;
					summary.ABSENCES.UNLAWFUL += !!sch.UNLAWFUL_COUNT ? sch.UNLAWFUL_COUNT : 0;
					summary.ABSENCES.TOTAL_DAYS += !!sch.DAY_COUNT ? sch.DAY_COUNT : 0;

					// Tardy summary
					if(sch.EARLY_DISMISSAL_FLG === 'Y' || sch.TARDY_FLG === 'Y') {
						if(sch.EXCUSED_STATUS === 'E') {
							summary.TARDY.EXCUSED.TARDY += !!sch.TARDY_COUNT ? sch.TARDY_COUNT : 0;
							summary.TARDY.EXCUSED.EARLY_DISMISSAL += !!sch.EARLY_DISMISSAL_COUNT ? sch.EARLY_DISMISSAL_COUNT : 0;
							summary.TARDY.EXCUSED.MINUTES += !!sch.TARDY_MINUTES ? sch.TARDY_MINUTES : 0;
						} else if(sch.EXCUSED_STATUS === 'L') {
							summary.TARDY.UNLAWFUL.TARDY += !!sch.TARDY_COUNT ? sch.TARDY_COUNT : 0;
							summary.TARDY.UNLAWFUL.EARLY_DISMISSAL += !!sch.EARLY_DISMISSAL_COUNT ? sch.EARLY_DISMISSAL_COUNT : 0;
							summary.TARDY.UNLAWFUL.MINUTES += !!sch.TARDY_MINUTES ? sch.TARDY_MINUTES : 0;
						} else {
							summary.TARDY.UNEXCUSED.TARDY += !!sch.TARDY_COUNT ? sch.TARDY_COUNT : 0;
							summary.TARDY.UNEXCUSED.EARLY_DISMISSAL += !!sch.EARLY_DISMISSAL_COUNT ? sch.EARLY_DISMISSAL_COUNT : 0;
							summary.TARDY.UNEXCUSED.MINUTES += !!sch.TARDY_MINUTES ? sch.TARDY_MINUTES : 0;
						}

						summary.TARDY.TOTAL_MINUTES += !!sch.TARDY_MINUTES ? sch.TARDY_MINUTES : 0;
					}
				}

				summary.TARDY.TOTAL_TARDY +=
					summary.TARDY.EXCUSED.TARDY + summary.TARDY.UNEXCUSED.TARDY + summary.TARDY.UNLAWFUL.TARDY;

				summary.TARDY.TOTAL_EARLY_DISMISSAL +=
					summary.TARDY.EXCUSED.EARLY_DISMISSAL + summary.TARDY.UNEXCUSED.EARLY_DISMISSAL + summary.TARDY.UNLAWFUL.EARLY_DISMISSAL;

				return summary;
			}
		}
	}
</script>

<style scoped>
	.card {
		position: relative;
		display: -webkit-box;
		display: -ms-flexbox;
		display: flex;
		-webkit-box-orient: vertical;
		-webkit-box-direction: normal;
		-ms-flex-direction: column;
		flex-direction: column;
		min-width: 0;
		word-wrap: break-word;
		background-color: #fff;
		background-clip: border-box;
		border: 1px solid rgba(0,0,0,.125);
		border-radius: .25rem;
	}

	.card-header:first-child {
		border-radius: calc(.25rem - 1px) calc(.25rem - 1px) 0 0;
	}

	.card-header {
		padding: .75rem 1.25rem;
		margin-bottom: 0;
		background-color: rgba(0,0,0,.03);
		border-bottom: 1px solid rgba(0,0,0,.125);
	}

	.collapse {
		display: none;
	}

	.collapse.show {
		display: block;
	}

	.card-body {
		-webkit-box-flex: 1;
		-ms-flex: 1 1 auto;
		flex: 1 1 auto;
		padding: 1.25rem;
	}

	.attendance-summary-table {
		border: 1px solid #E8E8E8;
		border-top: none;
	}

	.font-white {
		color: #FFFFFF;
	}
</style>
